import styled, { keyframes } from 'styled-components'

const loading = keyframes`  
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`
export const PaymentSectionContainer = styled.section`
    width: 100%;
    padding-top: 12px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    svg {
        path {
            stroke: ${properties => properties.theme.variables.colorPrimary};
        }
    }
    h1 {
        font-family: ${properties => properties.theme.variables.fontFamily.headline};
        font-weight: 600;
        font-size: 28px;
        letter-spacing: -0.48px;
        line-height: 1.2em;
        text-align: left;
        color: ${properties => properties.theme.variables.colorText};
    }
    h3 {
        height: 18px;
        font-family: ${properties => properties.theme.variables.fontFamily.title};
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 18px;
        color: ${properties => properties.theme.variables.colorText};

        a {
            color: ${properties => properties.theme.variables.colorPrimary};
            &:hover {
                color: ${properties => properties.theme.variables.colorPrimary};
                opacity: 0.8;
            }
        }
    }
    .loading span {
        animation: ${loading} 0.5s infinite alternate;
    }
    .loading span:nth-of-type(2) {
        animation-delay: 0.2s;
    }
    .loading span:nth-of-type(3) {
        animation-delay: 0.4s;
    }
    .loading span:nth-of-type(4) {
        animation-delay: 0.6s;
    }
    @media only screen and (min-width: 810px) {
        width: 350px;
    }
`

export const PaymentsMethodsList = styled.ul`
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    width: 100%;
    justify-content: center;
    gap: 16px;
    margin-top: 16px;
    list-style: none;
`
